module.exports = __webpack_public_path__ + "img/FGr_Notversorgung_und_Notinstandsetzung.d7148c29.svg";